import { defineStore } from "pinia";
import { ref } from "vue";
export const usePersistedCommonStore = defineStore("PersistedCommonStore", () => {
    const bycott_modal = ref(false);
    const do_not_show_modal = ref(false);
    const sellCryptoState = ref({
        state: false,
        depositTagMemo: undefined
    });
    const gatewayService = ref({
        serviceName: '',
        factorId: 0,
        trackId: 0,
        date: 0
    });
    const popupPushNotification = ref(null);
    const onAuthConnectionErrorFlag = ref(false);
    const doNotShowgatewayPayInitModal = ref(false);
    return {
        bycott_modal,
        do_not_show_modal,
        sellCryptoState,
        gatewayService,
        popupPushNotification,
        onAuthConnectionErrorFlag,
        doNotShowgatewayPayInitModal
    };
}, {
    persist: true,
});
